/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CommonProtocolsGetCreditsResponse,
  CommonProtocolsGetDownloadUrlRequest,
  CommonProtocolsGetDownloadUrlResponse,
  CommonProtocolsUpdateTranslateRequest,
  MarqCommonProtocolEmptyResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Common<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Common
   * @name CreditsList
   * @request GET:/common/credits
   */
  creditsList = (params: RequestParams = {}) =>
    this.http.request<CommonProtocolsGetCreditsResponse, any>({
      path: `/common/credits`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Common
   * @name DownloadUrlCreate
   * @request POST:/common/download-url
   */
  downloadUrlCreate = (data: CommonProtocolsGetDownloadUrlRequest, params: RequestParams = {}) =>
    this.http.request<CommonProtocolsGetDownloadUrlResponse, any>({
      path: `/common/download-url`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Common
   * @name TranslateCreate
   * @request POST:/common/translate
   */
  translateCreate = (data: CommonProtocolsUpdateTranslateRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/common/translate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
